/* eslint-disable @typescript-eslint/no-unsafe-return */

// change vite url based on environment
export function getAuthUrl() {
  const { hostname } = window.location;

  // get the localhost env variables
  if (
    hostname.includes("localhost") ||
    hostname.includes("2689241819.propelauthtest.com")
  ) {
    return import.meta.env.VITE_AUTH_URL;
  }

  // get staging env variables
  if (
    hostname.includes("fix-clean-staging.biodit.info") ||
    hostname.includes("auth.biodit.info")
  ) {
    return import.meta.env.VITE_AUTH_STAGING_URL;
  }

  if (hostname.includes("fix-and-clean.biodit.com")) {
    // production env goes here
    return import.meta.env.VITE_AUTH_PRODUCTION_URL;
  }

  return import.meta.env.VITE_AUTH_STAGING_URL;
}

// change api key for put request based on environment
export function getPropelAPI() {
  const { hostname } = window.location;

  // get the localhost env variables
  if (
    hostname.includes("localhost") ||
    hostname.includes("2689241819.propelauthtest.com")
  ) {
    return import.meta.env.VITE_PROPEL_API;
  }

  // get staging env variables
  if (
    hostname.includes("fix-clean-staging.biodit.info") ||
    hostname.includes("auth.biodit.info")
  ) {
    return import.meta.env.VITE_PROPEL_STAGING_API;
  }

  if (hostname.includes("fix-and-clean.biodit.com")) {
    // production env goes here
    return import.meta.env.VITE_PROPEL_PRODUCTION_API;
  }

  return import.meta.env.VITE_AUTH_STAGING_URL;
}
